import React, { useState } from "react"
import SEO from "../components/seo"
import { Link } from "gatsby"
import AdditionalLegal from "../components/additionalLegal"
const Warning = () => {
  const [cookiesCool, setCookiesCool] = useState(true)
  return (
    <>
      <SEO
        title="NetVideoGirls.com - Official Site"
        noTag={true}
        can={`https://netvideogirls.com/`}
      />
      <div className="warningArea">
        <h2>
          Please read and comply with the following
          <br />
          conditions before you continue:
        </h2>
        <div className="legalArea">
          <div className="disclaimer">
            <AdditionalLegal />
            <h3>Legal disclaimer</h3>

            <p>
              By accepting this agreement, I certify that I am over the age of
              consent in my jurisdiction and that I do not find images of nude
              adults, adults engaged in hardcore sex or other sexual porn videos
              and photos to be offensive or objectionable in any way. I am at
              least 18 years old and have the legal right to possess adult
              material, porn videos, naughty pictures and intimate erotic
              stories in my community.
              <br />I understand the standards and laws of my own community and
              I am solely responsible for my own actions. I will not attempt to
              bypass any security or access features of the Net Video Girls
              casting couch sex site without permission. If I use these services
              in violation of the above agreement, I understand I may be in
              violation of local or federal laws and I am solely responsible for
              my actions.
            </p>

            <p>
              By entering NetVideoGirls.com or viewing any of the amateur models
              having sex in videos produced on this site, I fully release and
              discharge the providers, owners and creators of this adult
              entertainment website from any and all liability. Book marking to
              a page on this server/site whereby this warning page is bypassed
              shall constitute an implicit acceptance of the foregoing terms
              herein set forth.
            </p>

            <p>
              By accepting this agreement, I certify that I am over the age of
              consent in my jurisdiction and that I do not find images of nude
              adults, adults engaged in hardcore sex or other sexual porn videos
              and photos to be offensive or objectionable in any way. I am at
              least 18 years old and have the legal right to possess adult
              material, porn videos, naughty pictures and intimate erotic
              stories in my community.
              <br />I understand the standards and laws of my own community and
              I am solely responsible for my own actions. I will not attempt to
              bypass any security or access features of the Net Video Girls
              casting couch sex site without permission. If I use these services
              in violation of the above agreement, I understand I may be in
              violation of local or federal laws and I am solely responsible for
              my actions.
            </p>

            <p>
              By entering NetVideoGirls.com or viewing any of the amateur models
              having sex in videos produced on this site, I fully release and
              discharge the providers, owners and creators of this adult
              entertainment website from any and all liability. Book marking to
              a page on this server/site whereby this warning page is bypassed
              shall constitute an implicit acceptance of the foregoing terms
              herein set forth.
            </p>
          </div>
        </div>
        <div className="check">
          <label>
            <input
              type="checkbox"
              checked={cookiesCool}
              onChange={e => {
                setCookiesCool(prev => !prev)
              }}
            />
            <i></i>I know you use cookies and think its neat!{" "}
            <Link to="/terms-and-conditions">Learn More</Link>
          </label>
        </div>
        <div className="twoBtns">
          {cookiesCool ? (
            <Link to="/home" className="enter">
              Enter Here
            </Link>
          ) : (
            <span className="enter">Enter Here</span>
          )}

          <a href="https://yahoo.com/" className="exit">
            Exit here
          </a>
        </div>
      </div>
    </>
  )
}

export default Warning
